import productInfoBox from "../../../../components/userCenter/public/productInfoBox.vue"; //产品信息库
import { post, fetch, Del, put } from "@/ask/axios";
import { getCookie } from "@/ask/cookiejs";
import menberMenu from "@/components/userCenter/public/menberPageMenu.vue";

export default {
  components: { productInfoBox, menberMenu },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },
      inquiryParam: "", //保存询盘用到的参数 单独放
      success: false, //弹框成功

      myHeaders: {
        ["X-JWT-TOKEN"]: getCookie("X-BY-EnTOKEN")
      },

      titNames: "My inquiry",
      titUrls: "",

      waitMesTime: [12, 24, 4],
      // 材积总和
      totalCFT: "",
      totalCBM: "",
      totalLB: "",
      totalUnit: "",
      totalKG: "",

      curWaitMesTime: 12, //当前选择的默认
      waitMesTimePick: 0, //被选中的index
      //自定义时间
      customTimeNum: 1,
      disabTime: true,

      // 货物信息
      radCargo: [
        {
          Quanlity: "",
          Long: "",
          Wide: "",
          Height: "",
          High: "",
          Volume: "",
          Weight: "",
          LongIN: "",
          WideIN: "",
          HighIN: "",
          VolumeCFT: "",
          WeightLB: "",
          isCol1: false,
          isCol2: false,
          isCol3: false,
          unitOptions: [
            { value: 1, label: "Carton" },
            { value: 2, label: "Pallet" },
            { value: 3, label: "Wooden Case" },
            { value: 4, label: "Other" }
          ],
          Unit: 1
        }
      ],
      expectedDate: "", //期望日期
      //文件上传
      upLoadData: {
        PathName: 'air/inquiry',
        IsTempFile: false
      }, //导入文件
      fileList1: [],
      goodsName: "", //货物品名

      inquiryRemark: "", // 备注
      airPort: "", //机场信息
      airPortInfo: "", //机场信息
      airPortOpt: "",
      inquiryName: "", ///询盘名称

      loading: false,
      VolumeUnit: 0,
      checkTip: {
        //验证提示信息
        goodsNameTip: false,
        expectedDateTip: false,
        airPortTip: false,
        inquiryNameTip: false,
        // 占位符的文字
        airPortPlace: 'If you have prefer airline',
        expectedDatePlace: "",
        goodsNamePlace: "Please enter product name separated by commas",
        inquiryNamePlace: "Purchase oder or description of shipment",
        inputUnitsTip: '',
        inputWeightTip: '',
        inputCBMTip: '',
        inputCFBTip: '',
        inputLBTip: '',
      },

      getQueryInfo: null,
      words: {
        from: "",
        to: "",
        orderServiceType: "",
        planDeliveryTime: "",
        shippingType: "Air Freight",
        CargoNameEn: "",
        GoodsReadyTime: "",
        startCityNameEn: ''
      },
      //设置禁止之前的日期选择
      expireTimeOption: {
        disabledDate: this.disabledDate //设置禁用状态，参数为当前日期，要求返回 Boolean
      },
      QueryType: 2,
      //总量信息计算
      unitOptions: [
        { value: 'CTNS', label: 'Carton' }//, { value: 'PLTS', label: 'Pallet' }, { value: 'WOODEN CASE', label: 'Wooden Case' }, { value: 'OTHER', label: 'Other' }
      ],
      unitValue: 'CTNS',
      inputUnits: null, //输入件数
      inputWeight: null, //输入重量
      inputCBM: null, //输入总体积
      inputLB: null,
      inputCFB: null,

    };
  },
  created() {
    this.Queryparams(); //获得传递过来的参数 并进行处理
    this.Words(); //显示文字
  },
  // 计算
  computed: {
    //计算属性周期函数
    //把选择LB单位，换算成KG,把选择CFT单位，换算成CBM,
    //sumUnits:'',sumKG:'',sumCBM:'',//总件数、总重量、总体积
    sumUnit() {
      //件数总计
      let num = 0;
      if (this.radCargo) {
        this.radCargo.forEach(e => {
          num += Number(e.Quanlity);
        });
        if (isNaN(num)) {
          return 0;
        }
      }
      this.totalUnit = num;
      return num;
    },
    //KG单位换算
    sumKG() {
      let num = 0;
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += Number(e.Quanlity) * Number(e.Weight);
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += Number(e.Quanlity) * (Number(e.WeightLB) * 0.4535924);
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }
      this.totalKG = num;
      return num.toFixed(3);
    },
    //磅单位换算
    sumLB() {
      let num = 0;
      //VolumeUnit=0 KG；VolumeUnit=1 LB
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += Number(e.Quanlity) * (Number(e.Weight) * 2.2046226);
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += Number(e.Quanlity) * Number(e.WeightLB);
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }
      this.totalLB = num;
      return num.toFixed(3);
    },

    //VolumeUnit=0 CBM；VolumeUnit=1 CFT
    //CBM单位换算
    sumCBM() {
      let num = 0;
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num +=
              ((Number(e.Long) * Number(e.Wide) * Number(e.Height)) / 1000000) *
              Number(e.Quanlity);
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num +=
              Number(e.LongIN) *
              Number(e.WideIN) *
              Number(e.HighIN) *
              Number(e.Quanlity) *
              0.000016387064;
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }
      this.totalCBM = num;
      return num.toFixed(4);
    },
    sumCFT() {
      let num = 0;
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num +=
              ((Number(e.Long) * Number(e.Wide) * Number(e.Height)) / 1000000) *
              Number(e.Quanlity) *
              35.3147248;
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num +=
              Number(e.LongIN) *
              Number(e.WideIN) *
              Number(e.HighIN) *
              0.000016387064 *
              35.3147248 *
              e.Quanlity;
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }
      this.totalCFT = num;
      return num.toFixed(4);
    }
  },
  methods: {
    disabledDate(time) {
      if (this.getQueryInfo) {
        if (
          this.getQueryInfo.stroeQuery.OrderServiceType == 1 ||
          this.getQueryInfo.stroeQuery.OrderServiceType == 4
        ) {
          return (
            time.getTime() <
            new Date(this.getQueryInfo.stroeQuery.GoodsReadyTime).getTime() +
            8.64e7 * 3
          );
        } else {
          return (
            time.getTime() <
            new Date(this.getQueryInfo.stroeQuery.GoodsReadyTime).getTime()
          );
        }
      }
    },
    //文字显示
    Words() {
      //debugger
      let AirInquiryOrder = this.inquiryParam.AirInquiryOrder;
      let OrderServiceType = AirInquiryOrder.OrderServiceType;
      //显示目的和其运地
      if (this.$route.query.from && this.$route.query.from !== 'checkList') {
        if (OrderServiceType == 1 || OrderServiceType == 2) {
          this.words.from =
            AirInquiryOrder.StartCityNameEn +
            "," +
            AirInquiryOrder.StartProNameEn +
            "," +
            AirInquiryOrder.StartCountryNameEn;
        } else {
          this.words.from =
            AirInquiryOrder.DepartureCode + "," + AirInquiryOrder.DepartureNameEn;
        }
      } else {
        //登录页选中的城市没有三字码的时候只显示英文城市名称
        if (AirInquiryOrder.DepartureCode) {
          if (AirInquiryOrder.DepartureCode.trim()) {
            this.words.from =
              AirInquiryOrder.DepartureCode + "," + this.words.startCityNameEn//AirInquiryOrder.DepartureNameEn;
          } else {
            this.words.from = this.words.startCityNameEn;
          }
        } else {
          if (OrderServiceType == 1 || OrderServiceType == 2) {
            this.words.from =
              AirInquiryOrder.StartCityNameEn +
              "," +
              AirInquiryOrder.StartProNameEn +
              "," +
              AirInquiryOrder.StartCountryNameEn;
          } else {
            this.words.from =
              AirInquiryOrder.DepartureCode + "," + AirInquiryOrder.DepartureNameEn;
          }
        }
      }

      if (OrderServiceType == 1 || OrderServiceType == 4) {
        this.words.to =
          this.getQueryInfo.curAddress.desCityInfo.description +
          "," +
          AirInquiryOrder.DestCountryNameEn;
      } else {
        this.words.to =
          AirInquiryOrder.DestinationCode +
          "," +
          AirInquiryOrder.DestinationNameEn;
      }
      //显示类型
      // this.words.orderServiceType =
      // '5':"FOB",
      // '6':"EXW",
      // '7':"FCA"
      switch (OrderServiceType) {
        case 1:
          this.words.orderServiceType = "Door to Door";
          break;
        case 2:
          this.words.orderServiceType = "Door to Terminal";
          break;
        case 3:
          this.words.orderServiceType = "Terminal to Terminal";
          break;
        case 4:
          this.words.orderServiceType = "Terminal to Door";
          break;
        case 5:
          this.words.orderServiceType = "FOB";
          break;
        case 6:
          this.words.orderServiceType = "EXW";
          break;
        case 7:
          this.words.orderServiceType = "FCA";
          break;
      }
      // 显示货物
      //console.log("====,", AirInquiryOrder, AirInquiryOrder.CargoNameEn.split(","));
      this.words.CargoNameEn = AirInquiryOrder.CargoNameEn;
      this.words.GoodsReadyTime = new Date(
        AirInquiryOrder.PlanDeliveryTime
      ).Format("yyyy-MM-dd");
    },

    //--------货物信息-------
    // 添加货物
    addPackage() {
      //增加包裹
      this.radCargo.push(this.addPackItem());
    },
    addPackItem() {
      return {
        Quanlity: "",
        Long: "",
        Wide: "",
        Height: "",
        High: "",
        Volume: "",
        Weight: "",
        LongIN: "",
        WideIN: "",
        HighIN: "",
        VolumeCFT: "",
        WeightLB: "",
        isCol1: false,
        isCol2: false,
        isCol3: false,
        unitOptions: [
          { value: 1, label: "Carton" },
          { value: 2, label: "Pallet" },
          { value: 3, label: "Wooden Case" },
          { value: 4, label: "Other" }
        ],
        Unit: 1
      };
    },
    delPackage(index) {
      //删除包裹
      if (this.radCargo.length > 1) {
        this.radCargo.splice(index, 1);
      }
    },
    // 查询参数的处理
    Queryparams() {
      this.getQueryInfo = JSON.parse(sessionStorage.getItem("customerInquiry")); //得到查询信息
      if (this.getQueryInfo) {
        let QueryPrice = this.getQueryInfo.stroeQuery;
        let curAddress = this.getQueryInfo.curAddress;
        let CargoNameEn = this.getQueryInfo.CargoNameEn;
        let CargoNameCn = this.getQueryInfo.CargoNameCn;
        this.words.startCityNameEn = this.getQueryInfo.curAddress.startAirPortInfo.CityNameEn

        // if(this.$route.query.from==='checkList'){
        //   this.words.from =
        // }

        if (QueryPrice.QueryGoodType == 1) {
          this.VolumeUnit = QueryPrice.GoodInfos[0].VolumeUnit;
          this.radCargo = QueryPrice.GoodInfos;
          if (this.VolumeUnit == 0) {
            this.radCargo.forEach(ele => {
              ele.LongIN = "";
              ele.WideIN = "";
              ele.HighIN = "";
              ele.WeightLB = "";
            });
          } else {
            this.radCargo.forEach(ele => {
              ele.Long = "";
              ele.Wide = "";
              ele.High = "";
              ele.Height = "";
              ele.Weight = "";
            });
          }
        }
        let StartAreaInfo = {
          CountryKey: "",
          Country_NameCh: "",
          Country_NameEn: "",
          ProvinceKey: "",
          ProvinceNameCh: "",
          ProvinceNameEn: "",
          CityAreaKey: "",
          CityAreaNameCh: "",
          CityAreaNameEn: "",
          CityKey: "",
          CityNameCh: "",
          CityNameEn: ""
        };
        let StartAirPortInfo = {
          AirportCode3: "",
          AirportNameCh: "",
          AirportNameEn: ""
        };
        // let CityInfo = { ProvinceKey:'', Province_NameCh:'', Province_NameEn:'', CityNameEn:'', CityNameCh:'', CityKey:''}
        let EndAirPortInfo = {
          AirportCode3: "",
          AirportNameCh: "",
          AirportNameEn: ""
        };
        let DestAllInfo = {
          AirportCode3: "",
          AirportNameCh: "",
          AirportNameEn: ""
        };

        if (
          QueryPrice.OrderServiceType == 1 ||
          QueryPrice.OrderServiceType == 2
        ) {
          StartAreaInfo = curAddress.startCityInfo; //1 2 有其运地
        } else {
          StartAirPortInfo = curAddress.startAirPortInfo; // 3 4 有起运机场
        }
        let DestinationCode = "";
        let DestinationName = "";
        let DestinationNameEn = "";
        let DestCountryKey = "";
        let DestCountryNameCn = "";
        let DestCountryNameEn = "";
        let CityInfo = {};
        if (
          QueryPrice.OrderServiceType == 1 ||
          QueryPrice.OrderServiceType == 4
        ) {
          CityInfo = curAddress.desCityInfo; // 1 4有城市
          let DestCountryKeyInfo = curAddress.desCountryInfo; //目的国家必有
          DestCountryKey = DestCountryKeyInfo.CountryKey;
          DestCountryNameCn = DestCountryKeyInfo.NameCh;
          DestCountryNameEn = DestCountryKeyInfo.NameEn;
          if (curAddress.desAirPortInfo) {
            EndAirPortInfo = curAddress.desAirPortInfo;
            DestinationCode = EndAirPortInfo.AirportCode3;
            DestinationName = EndAirPortInfo.AirportNameCh;
            DestinationNameEn = EndAirPortInfo.AirportNameEn;
          }
        } else {
          DestAllInfo = curAddress.desAllInfo;
          DestinationCode = DestAllInfo.AirportCode3;
          DestinationName = DestAllInfo.AirportNameCh;
          DestinationNameEn = DestAllInfo.AirportNameEn;
          DestCountryKey = "";
          DestCountryNameCn = DestAllInfo.CountryNameCh;
          DestCountryNameEn = DestAllInfo.CountryNameEn;
        }
        //服务类型为FOB，EXW，FCA类型时，起始地为选择的条款城市
        if (QueryPrice.OrderServiceType == 5 ||
          QueryPrice.OrderServiceType == 6 || QueryPrice.OrderServiceType == 7) {
          StartAreaInfo = curAddress.startAirPortInfo
        }

        this.inquiryParam = {
          AirInquiryOrder: "",
          GoodsVolumeList: "",
          AttachList: "",
          LstDestinationTerms: [],
          "platform_type": "web",
          "entrance": "Submit inquiry"
        }; //保存报价的传参格式
        this.inquiryParam.AirInquiryOrder = {
          OrderServiceType: QueryPrice.OrderServiceType,
          CargoIDs: typeof (QueryPrice.CargoTypeIDs) == 'string' ? QueryPrice.CargoTypeIDs : QueryPrice.CargoTypeIDs.join(),
          PlanDeliveryTime: QueryPrice.GoodsReadyTime,
          CargoNameCn: CargoNameCn,
          CargoNameEn: CargoNameEn,
          StartCountryKey: StartAreaInfo.CountryKey
            ? StartAreaInfo.CountryKey
            : "3c48f3d4-8f99-4721-9e88-2ff6f77b10bf",
          StartCountryNameCn: StartAreaInfo.Country_NameCh
            ? StartAreaInfo.Country_NameCh
            : "中国",
          StartCountryNameEn: StartAreaInfo.Country_NameEn
            ? StartAreaInfo.Country_NameEn
            : "China",
          StartProKey: StartAreaInfo.ProvinceKey,
          StartProNameCn: StartAreaInfo.Province_NameCh,
          StartProNameEn: StartAreaInfo.Province_NameEn,
          StartCityAreaKey: StartAreaInfo.CityAreaKey,
          StartCityAreaNameCn: StartAreaInfo.CityAreaNameCh,
          StartCityAreaNameEn: StartAreaInfo.CityAreaNameEn,
          StartCityKey: StartAreaInfo.CityKey,
          StartCityNameCn: StartAreaInfo.CityNameCh,
          StartCityNameEn: StartAreaInfo.CityNameEn != "" ? StartAreaInfo.CityNameEn : StartAreaInfo.City_NameEn,
          DestCountryKey: DestCountryKey,
          DestCountryNameCn: DestCountryNameCn,
          DestCountryNameEn: DestCountryNameEn,
          DepartureCode: StartAirPortInfo.AirportCode3 || StartAirPortInfo.CityCode,
          DepartureName: StartAirPortInfo.AirportNameCh,
          DepartureNameEn: StartAirPortInfo.AirportNameEn || StartAirPortInfo.CityNameEn,
          DestinationCode: DestinationCode,
          DestinationName: DestinationName,
          DestinationNameEn: DestinationNameEn,
          BondValue: QueryPrice.BondValue,
          IsDestCustoms: QueryPrice.IsDestCustoms,
          IsBond: QueryPrice.IsBond,
          BondType: QueryPrice.BondType,
          IsSHReport: QueryPrice.IsSHReport,
          DestAddressDesc: CityInfo.Primary_Description
        };
        this.inquiryParam.LstDestinationTerms = CityInfo.lstTerms;
      }
    },
    // 产品信息库 ----
    clkProductBox() {
      this.$refs.productBox.clkDialog();
    },
    // 获得产品信息
    showMsgProduct(msg) {
      let nameEnObj = "";
      let nameEnArr = [];
      msg.forEach(e => {
        nameEnArr.push(e.EnglishName);
      });
      nameEnObj = nameEnArr.join(",");
      this.goodsName = nameEnObj;
    },

    //附件上传------

    handleBatExceed(files, fileList) {
      //限制最大个数的
      this.$message.warning("Upload up to 5 attachments!");
    },
    beforeBatUpload(file, fileList) {
      //上传文件之前做验证
      const extension =
        " .jpg, .jpeg, .gif, .png, .bmp, .pic, .doc, .docx, .rar, .xls, .xlsx, .pdf, .zip, .7z, ";
      var fileName = file.name;
      var ext =
        fileName.substring(fileName.lastIndexOf("."), fileName.length) + ", ";

      if (extension.indexOf(ext) == -1) {
        this.$confirm(
          "The imported file can only be in" + extension + "format!",
          "",
          {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false, //去掉取消按钮
            showClose: false, //去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }
        )
          .then(() => { })
          .catch(() => { });
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 4;
      const isLtZeroM = file.size / 1024 / 1024 > 0;
      if (!isLt2M) {
        this.$confirm("Upload file size is over 4mb!", "", {
          customClass: "custom-message-box", //自定义添加Class
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
          closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
          showCancelButton: false, //去掉取消按钮
          showClose: false, //去掉右上角的取消（X）
          // type: 'warning',
          center: true
        })
          .then(() => { })
          .catch(() => { });
        return false;
      }
      if (!isLtZeroM) {
        this.$confirm("The file size is 0kb, please re-upload!", "", {
          customClass: "custom-message-box", //自定义添加Class
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
          closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
          showCancelButton: false, //去掉取消按钮
          showClose: false, //去掉右上角的取消（X）
          // type: 'warning',
          center: true
        })
          .then(() => { })
          .catch(() => { });
        return false;
      }
      //上传文件名不能超多100个字符
      if (fileName.length > 100) {
        this.$confirm(
          "The file name is over 100 characters,please re-upload！",
          "",
          {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false, //去掉取消按钮
            showClose: false, //去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }
        )
          .then(() => { })
          .catch(() => { });
        return false;
      }
      return true;
    },
    //附件上传成功
    batAttSuccess(file, fileList) {
      if (file.Results.UploadPath) {
        this.fileList1.push({
          Url: file.Results.UploadPath,
          OriginName: fileList.name,
          BuildName: fileList.name,
          AttachType: 6, //1：提单附件，2：报关底单，3：保险凭证，4：其他，5：订单资料，6，客户上传附件，通过接口上传的，没有固定哪个类型，都当订单资料类型处理
          UploadType: 0 //上传人.0：客户上传，1：后台上传，2：供应商上传
        });
      }
    },
    //删除
    clkDelFile(index) {
      this.fileList1.splice(index, 1);
    },
    // ------

    //验证事件Blur
    goBlurTotal(val) {
      var type = `${val}Tip`
      let cantZero = ['inputWeight', 'inputCBM', 'inputCFB', 'inputLB']
      if (cantZero.includes(val)) {
        if (Number(this[val]) <= 0) {
          this[val] = ''
          this.checkTip[type] = 'Required'
        }
      }
      if (!this[val]) {
        this.checkTip[type] = 'Required'
      } else {
        this.checkTip[type] = ''
      }
    },
    //跟据传来的类型，拼接操作
    goblur(type, index) {
      var re = /^\d+(?=\.{0,1}\d+$|$)/;
      var QuanlityReg = /^[0-9]*[1-9][0-9]*$/; //件数正则
      if (!index) {
        let Tip = `${type}Tip`;
        let Place = `${type}Place`;
        if (type == "goodsName") {
          //console.log(this[type]);
          if (this[type].trim() == "") {
            this[type] = "";
            this.checkTip[Tip] = true;
            this.checkTip[Place] = "Required";
            return false;
          }
        }
        if (type == "expectedDate" || type == "inquiryName") {
          if (type == "inquiryName" && this[type].trim() == "") {
            this[type] = "";
          }
          if (this[type] == "") {
            this[type] = "";
          }
          if (this[type] == "" || !this[type]) {
            this[type] = "";
            this.checkTip[Tip] = true;
            if (type == "inquiryName") {
              this.checkTip[Place] = "Required";
              return false;
            } else if (type == "expectedDate") {
              this.checkTip[Place] = " Required";
              return false;
            }
            // else {
            //   this.checkTip[Place] = ' 航空公司不能为空'
            //   return false
            // }
          } else {
            this.checkTip[Tip] = false;
            if (type == "inquiryName") {
              this.checkTip[Place] = "Required";
            } else if (type == "expectedDate") {
              this.checkTip[Place] = "Required";
            } else {
              this.checkTip[Place] = " ";
            }
          }
        }
      } else {
        // //这里时详细信息的验证
        if (
          ["Wide", "Long", "Height", "LongIN", "WideIN", "HighIN"].includes(
            type
          )
        ) {
          this.radCargo[index - 1]["isCol2"] = true;
        }
        if (["WeightLB", "Weight"].includes(type)) {
          this.radCargo[index - 1]["isCol3"] = true;
        }
        if (["Quanlity"].includes(type)) {
          this.radCargo[index - 1]["isCol1"] = true;
        }

        if (
          type == "WeightLB" ||
          type == "LongIN" ||
          type == "WideIN" ||
          type == "HighIN"
        ) {
          if (
            this.radCargo[index - 1][type] == 0 ||
            this.radCargo[index - 1][type] == "."
          ) {
            this.radCargo[index - 1][type] = "";
            return false;
          }
          if (!re.test(this.radCargo[index - 1][type])) {
            this.radCargo[index - 1][type] = "";
            return false;
          }
        }
        if (
          type == "Weight" ||
          type == "Long" ||
          type == "Wide" ||
          type == "Height"
        ) {
          if (
            this.radCargo[index - 1][type] == 0 ||
            this.radCargo[index - 1][type] == "."
          ) {
            this.radCargo[index - 1][type] = "";
            return false;
          }
          if (!re.test(this.radCargo[index - 1][type])) {
            this.radCargo[index - 1][type] = "";
            return false;
          }
        } else if (type == "Quanlity") {
          if (!QuanlityReg.test(this.radCargo[index - 1][type])) {
            this.radCargo[index - 1][type] = "";
            return false;
          }
        }
      }
    },
    checkNumInt(ctrValue) {
      var reg = /^[0-9]*[1-9][0-9]*$/;
      if (reg.test(ctrValue)) {
        if (ctrValue.length > 4) {
          ctrValue = ctrValue.substring(0, 4);
        }
        return ctrValue;
      }
    },
    checkNumIntl(ctrValue) {
      if (ctrValue == 0) {
        ctrValue = '';
      }
      if (ctrValue) {
        ctrValue = ctrValue.replace(/\D/g, '');
        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;
        if (le > 4) {
          ctrValue = arr[0].substring(0, 4);
        }
      }
      return ctrValue;
    },
    checkNum(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, "");
        if (ctrValue.indexOf(".") > -1) {
          let s = ctrValue.substring(ctrValue.indexOf(".") + 1);
          if (s.length > 3) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf(".") + 4);
          }
          if (s.indexOf(".") > -1) {
            ctrValue = ctrValue.substring(0, ctrValue.length - 1);
          }
        }
        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;
        if (le > 7) {
          let int = arr[0].substring(0, 7);
          if (ctrValue.indexOf(".") > -1) {
            ctrValue = int + "." + arr[1];
          } else {
            ctrValue = int;
          }
        }
        return ctrValue;
      }
    },
    checkNumFour(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, '');
        if (ctrValue.indexOf('.') > -1) {
          let s = ctrValue.substring(ctrValue.indexOf('.') + 1)
          if (s.length > 4) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf('.') + 5);
          }
        }

        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;

        if (le > 8) {
          let int = arr[0].substring(0, 8);
          if (ctrValue.indexOf('.') > -1) {
            ctrValue = int + '.' + arr[1];
          } else {
            ctrValue = int
          }
        }

        return ctrValue;
      }
    },
    //数字验证
    checkNumTwo(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, "");
        if (ctrValue.indexOf(".") > -1) {
          let s = ctrValue.substring(ctrValue.indexOf(".") + 1);
          if (s.length > 2) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf(".") + 3);
          }
          if (s.indexOf(".") > -1) {
            ctrValue = ctrValue.substring(0, ctrValue.length - 1);
          }
        }
        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;

        if (le > 8) {
          let int = arr[0].substring(0, 8);
          if (ctrValue.indexOf(".") > -1) {
            ctrValue = int + "." + arr[1];
          } else {
            ctrValue = int;
          }
        }
        return ctrValue;
      }
    },
    // 得到等待时间
    getWaitMesTime(index) {
      this.waitMesTimePick = index;
      this.curWaitMesTime = this.waitMesTime[this.waitMesTimePick];
      //自定义时间按钮
      this.disabTime = true;
      this.customTimeNum = 1;
    },
    clkCustomTime() {
      //自定义时间
      this.disabTime = false;
      this.waitMesTimePick = null;
      this.curWaitMesTime = this.customTimeNum;
    },
    chgInputNum() {
      //自定义时间
      this.curWaitMesTime = this.customTimeNum;
    },
    // 请求
    // 航空公司
    querySearch(query) {
      if (query !== "") {
        this.loading = true;
        this.api.url =
          this.$api02 + "/api/EbayCustomer/Airport/GetAirCompanies";
        this.api.param = {
          searchText: query
        };
        fetch(this.api.url, this.api.param).then(res => {
          this.airPortOpt = res.Results;
          // let index = ''
          // for(let i = 0 ; i<this.airPortOpt.length; i++) {
          //   if(this.airPortOpt[i].AirCompanyCode2.toLowerCase() == query.toLowerCase()){
          //     index = i
          //   }
          // }
          // if(index != '' ) {
          //   this.airPortOpt.unshift(this.airPortOpt[index]) //此时length长度+1 所以splice 要加1
          //   this.airPortOpt.splice(index+1,1)
          // }
          this.loading = false;
        });
      } else {
        this.airPortOpt = [];
      }
    },

    clearOpt() {
      if (!this.airPort) {
        this.airPortOpt = [];
      }
    },

    //筛选出航空信息
    getAirPortInfo(value) {
      //console.log(value, this.airPortOpt);
      this.airPortInfo = this.airPortOpt.filter(item => item.Id === value)[0];
    },
    // 检查所有验证
    checkAllInfo() {
      let check1 = this.goblur("goodsName");
      // let check2 = this.goblur('airPort')
      //let check3 = this.goblur("inquiryName");
      let check4 = this.goblur("expectedDate");
      let check5 = true;
      if (this.QueryType == 2) {
        if (check1 === false || check4 === false || check5 === false) {
          return false
        } else {
          return true
        }
      } else {
        if (this.VolumeUnit == 0) {
          this.radCargo.forEach(el => {
            if (
              !el.Height ||
              !el.Long ||
              !el.Wide ||
              !el.Quanlity ||
              !el.Weight
            ) {
              el.isCol1 = true;
              el.isCol2 = true;
              el.isCol3 = true;
              return (check5 = false);
            }
          });
        } else {
          this.radCargo.forEach(el => {
            if (
              !el.HighIN ||
              !el.LongIN ||
              !el.WideIN ||
              !el.Quanlity ||
              !el.WeightLB
            ) {
              el.isCol1 = true;
              el.isCol2 = true;
              el.isCol3 = true;
              return (check5 = false);
            }
          });
        }
        if (
          check1 === false ||

          check4 === false ||
          check5 === false
        ) {
          return false;
        }
      }
      // if(!flag)  return false
      // if(!this.goodsName) { this.checkTip.goodsNameTip = true; return false}
      // if(!this.inquiryName) {this.checkTip.inquiryNameTip = true; return false}
      // if(!this.expectedDate) {this.checkTip.expectedDateTip = true; return false }
      // console.log("444")
      // if(!this.airPort) {this.checkTip.airPortTip = true; return false}
    },
    // 询盘保存
    inQuiryStroe() {
      let check = this.checkAllInfo();
      if (check == false) {
        return false;
      }
      if (this.QueryType == 1) {
        if (this.VolumeUnit == 0) {
          this.radCargo.forEach(el => {
            el.High = el.Height;
          });
        }
      }

      // //埋点-提交询价
      // this.submitInquiry(
      //   this.words.from,
      //   this.inquiryParam.AirInquiryOrder.StartCountryNameEn,
      //   this.words.to,
      //   this.inquiryParam.AirInquiryOrder.DestCountryNameEn,
      //   this.sumKG,
      //   this.words.orderServiceType,
      //   this.sumCBM,
      //   "",
      //   this.sumUnit,
      //   this.inquiryParam.AirInquiryOrder.CargoNameEn
      // );
      //debugger
      //console.log("提交询盘参数======", this.inquiryParam);
      this.api.url = this.$api03 + "/api/TradeCustomer/InquiryOrder/AddOrderEn";
      this.success = true; //弹框出来
      let aa = new Promise((resolve, reject) => {
        post(this.api.url, this.inquiryParam).then(response => {
          resolve(response);
        });
      });
      return aa
    },

    inQuiryData() {
      let AcceptRepType = 0; //如果是自定义的就传1，不是就是0
      if (this.disabTime == false) {
        AcceptRepType = 1;
      } else {
        AcceptRepType = 0;
      }
      let PackageQuanlity, VolumeCBM, Weight, WeightLB, VolumeCFT
      if (this.QueryType == 1) {
        PackageQuanlity = this.totalUnit
        VolumeCBM = this.totalCBM
        Weight = this.totalKG
        WeightLB = this.totalLB
        VolumeCFT = this.totalCFT

      } else {
        PackageQuanlity = this.inputUnits
        if (this.VolumeUnit == 0) {
          VolumeCBM = this.inputCBM
          Weight = this.inputWeight
          WeightLB = this.inputWeight * 2.2046226
          VolumeCFT = this.inputCBM * 35.3147248;
        } else {
          VolumeCBM = this.inputCFB * 0.0283168
          Weight = this.inputLB * 0.4535924
          VolumeCFT = this.inputCFB
          WeightLB = this.inputLB
        }
      }

      let inQuiryData = {
        inquiryName: this.inquiryName,
        InquiryType: 1,
        ExpectArrDate: this.expectedDate,
        goodsName: this.goodsName,
        AirCompanyKey: this.airPortInfo ? this.airPortInfo.Id : "",
        AirCompanyNameCn: this.airPortInfo
          ? this.airPortInfo.AirCompanyNameCh
          : "",
        AirCompanyNameEn: this.airPortInfo
          ? this.airPortInfo.AirCompanyNameEn
          : "",
        AirCompanyCode2: this.airPortInfo
          ? this.airPortInfo.AirCompanyCode2
          : "",
        AirCompanyCode3: this.airPortInfo
          ? this.airPortInfo.AirCompanyCode3
          : "",
        AcceptReplyTime: this.curWaitMesTime,
        AcceptRepType: AcceptRepType, //如果是自定义的就传1，不是就是0
        Remark: this.inquiryRemark,
        QueryGoodType: this.QueryType,
        PackageQuanlity: PackageQuanlity,
        VolumeCBM: VolumeCBM,
        Weight: Weight,
        WeightLB: WeightLB,
        VolumeCFT: VolumeCFT,
        VolumeUnit: this.VolumeUnit,
        Unit: 5
      };

      this.inquiryParam.AirInquiryOrder = {
        ...this.inquiryParam.AirInquiryOrder,
        ...inQuiryData
      };
      //debugger
      //console.log(this.api.param.AirInquiryOrder)
      //this.inquiryParam.GoodsVolumeList = this.radCargo;
      if (this.QueryType == 1) {
        this.inquiryParam.GoodsVolumeList = this.radCargo
      } else {
        let radCargo = {
          Quanlity: this.inputUnits,
          Long: '',
          Wide: '',
          Height: '',
          High: '',
          Volume: VolumeCBM,
          Weight: Weight,
          LongIN: '',
          WideIN: '',
          HighIN: '',
          VolumeCFT: VolumeCFT,
          WeightLB: WeightLB,
          isCol1: true, isCol2: true, isCol3: true,

        }
        this.inquiryParam.GoodsVolumeList = radCargo
      }
      this.inquiryParam.AttachList = this.fileList1;
    },
    JumpPgae(res) {
      setTimeout(() => {
        if (res.IsOK) {
          this.success = false;
          window.location.href = "/myInquiry/airInquiry";
        } else if (res.IsOK === false) {
          this.success = false;
          this.$alert(res.Message, "", {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "Confirm",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
            // showCancelButton:false,//去掉取消按钮
            showClose: false, //去掉右上角的取消（X）
            // type: 'warning',
            center: true
          });
        }
      }, 3000);
    },
    async inQuiryBefore() {
      this.inQuiryData();
      let res = await this.inQuiryStroe(); //等待执行
      this.JumpPgae(res); //跳转页面
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/myInquiry/customerInquiry.js